import {h, Fragment} from "preact"
import { useAppStateSelector } from "@nosto/preact"
import { useEffect, useMemo } from "preact/hooks"
import { currency } from "../helpers"
import { isUS } from "../config"

import Product from "./Product"

export default function Products() {
    const {
        products,
        loading,
        pageType
    } = useAppStateSelector(state => ({ 
        products: state.response.products, 
        loading: state.loading,
        pageType: state.pageType
    }))

    const isCategory = useMemo(() => pageType === "category", [ pageType ])

    useEffect(() => {
        if(!isUS && typeof window.loadReviewsIoRatingSnippets === 'function') {
            window.loadReviewsIoRatingSnippets();
        }
    }, [ products?.hits, isUS ])

    useEffect(() => {
        if(!window.Nosto?.migrateToShopifyMarket) return;
        window.Nosto.migrateToShopifyMarket({
            productSectionElement: '.ns-serp .ns-markets',
            productHandleAttribute: 'data-handle',
            productUrlElement: '.ns-serp .product-card__link',
            priceElement: '.ns-serp .price-item--sale',
            listPriceElement: '.ns-serp .price-item--regular',
        }).then(() => {
            document.querySelectorAll('.ns-serp .ns-markets').forEach(el => {
                const priceEl = el.querySelector('.price-item--sale'), 
                    listPriceEl = el.querySelector('.price-item--regular');
                
                if(priceEl && currency !== "USD") {
                    priceEl.textContent = `${priceEl.textContent} ${currency}`;
                }
                if(listPriceEl && currency !== "USD") {
                    listPriceEl.textContent = `${listPriceEl.textContent} ${currency}`;
                }
                el.classList.remove('ns-markets');
            })
        })
    }, [ products?.hits ])

    return (
        <div class="ns-product-grid max-w-screen-xl mx-auto" style={loading ? "opacity: 0.3;" : ""}>
            {products.hits.map((hit, index) => {
                return <Product 
                    key={hit.productId || index} 
                    isCategory={isCategory}
                    product={hit} 
                />
            })}
        </div>
    )
}
